import React, { useContext, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { useSelector } from "react-redux";

import getCitiesNearby, { City } from "api/requests/getCitiesNearby";
import ConfigContext from "context/ConfigContext";
import LocationContext from "context/LocationContext";
import { Location } from "custom-types/Location";
import { getDomainCountryCode } from "redux/selectors/config";

import CitiesNearby, { Filter } from "./CitiesNearby";

type Props = {
  heading?: string;
  subheading?: string;
  showFilterTabs: boolean;
  location?: Location;
};

const CitiesNearbyModule = ({
  heading,
  subheading,
  showFilterTabs,
  location,
}: Props) => {
  const { retailType } = useContext(ConfigContext);
  const { finderLocation } = useContext(LocationContext);

  const [ref, inView] = useInView({
    threshold: 0,
    triggerOnce: true,
  });

  const [cities, setCities] = useState<City[]>([]);
  const [loading, setLoading] = useState(true);

  const countryCode = useSelector(getDomainCountryCode);
  const getCitiesData = async (filter: Filter = "all") => {
    const params = {
      countryCode,
      location: location || finderLocation,
      retailType,
      ...(filter !== "all" && { [filter]: true }),
    };
    const response = await getCitiesNearby(params);

    if (response.length > 0) {
      setCities(response);
    }
  };

  let currentLocation = {};

  useEffect(() => {
    if (inView && loading && currentLocation !== finderLocation) {
      getCitiesData();
      currentLocation = finderLocation;
      setLoading(false);
    }
  }, [inView, finderLocation]);

  return (
    <div ref={ref} data-testid="cities-nearby" role="complementary">
      {cities.length > 0 && (
        <CitiesNearby
          heading={heading}
          subheading={subheading}
          cities={cities}
          showFilterTabs={showFilterTabs}
          handleFilterCities={getCitiesData}
        />
      )}
    </div>
  );
};

export default CitiesNearbyModule;
